import { render, staticRenderFns } from "./Edit_service.vue?vue&type=template&id=1c80bed8&scoped=true&"
import script from "./Edit_service.vue?vue&type=script&lang=js&"
export * from "./Edit_service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c80bed8",
  null
  
)

export default component.exports